import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BLOG } from "@/lib/site";
import { useSEO } from "@/lib/seo";
import SectionHeading from "@/components/SectionHeading";

export default function Blog() {
  useSEO({
    title: "Blog — Ayurvedic Wisdom for Women",
    description: "Articles on PCOS, fertility, pregnancy, menopause and Ayurveda by Dr. Anita Chaudhari of Nari Arogya, Pune.",
    path: "/blog",
  });

  return (
    <>
      <section className="pt-32 pb-14 lotus-bg" data-testid="blog-hero">
        <div className="na-container text-center">
          <SectionHeading
            eyebrow="From the Journal"
            title="Wisdom for women's wellness"
            subtitle="Practical, evidence-informed articles on the topics that matter most."
            align="center"
          />
        </div>
      </section>

      <section className="section">
        <div className="na-container grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {BLOG.map((b) => (
            <Link to={`/blog/${b.slug}`} key={b.slug} className="na-card overflow-hidden group" data-testid={`blog-item-${b.slug}`}>
              <div className="aspect-[16/10] overflow-hidden">
                <img src={b.cover} alt={b.title} className="w-full h-full object-cover group-hover:scale-105 transition duration-700" loading="lazy" />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 text-xs text-[color:var(--na-muted)]">
                  <span className="px-2.5 py-1 rounded-full bg-[color:var(--na-teal)]/10 text-[color:var(--na-teal)] font-semibold">{b.tag}</span>
                  <span>{b.date}</span>
                  <span>·</span>
                  <span>{b.read}</span>
                </div>
                <h3 className="mt-3 text-2xl leading-snug group-hover:text-[color:var(--na-teal)] transition">{b.title}</h3>
                <p className="mt-2 text-sm text-[color:var(--na-muted)] leading-relaxed">{b.excerpt}</p>
                <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-[color:var(--na-teal)] group-hover:text-[color:var(--na-maroon)] transition">
                  Read article <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
